import { render, staticRenderFns } from "./QBetPage.vue?vue&type=template&id=0c14af81"
import script from "./QBetPage.vue?vue&type=script&lang=js"
export * from "./QBetPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports